import { ProgressSpinner } from 'callahan-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ManifestTable from './ManifestTable'
import { loadManifestInfo } from '../../actions/manifest-info-actions'
import BackButton from '../../components/BackButton'
import { formatDate, timeAgoForManifestFileDate } from '../../utils/date-utils.js'

import '../default.css'
import './manifest-info.css'

const propTypes = {
  loadManifestInfoError: PropTypes.bool,
  manifestInfoData: PropTypes.array,
  loadManifestInfoInProgress: PropTypes.bool
}

export class ManifestInfo extends Component {
  componentDidMount() {
    this.props.dispatch(loadManifestInfo())
  }

  static renderManifestTitle(manifest) {
    return (
      <div className="manifest-name">
        <u>{manifest.filename}</u>{' '}
        <span title={formatDate(manifest.date)}>
          (
          {timeAgoForManifestFileDate(
            manifest.filename.substring(manifest.filename.lastIndexOf('_') + 1)
          )}
          )
        </span>
      </div>
    )
  }

  render() {
    const manifestHasData =
      typeof this.props.manifestInfoData !== 'undefined' &&
      !this.props.loadManifestInfoError &&
      this.props.manifestInfoData !== null
    const manifestInfoLoading = this.props.loadManifestInfoInProgress

    const listOfManifestPaths = manifestHasData
      ? this.props.manifestInfoData.flatMap(manifest => manifest.paths)
      : []

    return (
      <div className="main-content">
        <div className="title-bar">
          <BackButton />
          <h1 className="page-title">Manifest Info</h1>
          <div className="title-right-padding" />
        </div>
        <hr />
        <div className="content">
          <h2>
            {manifestInfoLoading && (
              <span>
                <ProgressSpinner size="small" />
              </span>
            )}

            {manifestHasData && (
              <div>
                List of live manifest(s):
                {this.props.manifestInfoData.map(manifest =>
                  ManifestInfo.renderManifestTitle(manifest)
                )}
              </div>
            )}

            {!(manifestInfoLoading || manifestHasData) &&
              (typeof this.props.manifestInfoData !== 'undefined'
                ? this.props.manifestInfoData.message
                : 'Could not connect')}
          </h2>
          {manifestHasData && <ManifestTable displayData={listOfManifestPaths} />}
        </div>
      </div>
    )
  }
}

ManifestInfo.propTypes = propTypes

// map Error and manifestInfoData state to props, then change state accesses to prop acceses
function mapStateToProps(state) {
  const { manifestInfo } = state
  return {
    manifestInfoData: manifestInfo.manifestInfoData,
    loadManifestInfoError: manifestInfo.loadManifestInfoError,
    loadManifestInfoInProgress: manifestInfo.loadManifestInfoInProgress
  }
}

export default connect(mapStateToProps)(ManifestInfo)



// WEBPACK FOOTER //
// ./src/pages/ManifestInfo/ManifestInfo.js